<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="$refs.menuAddOrUpdate.edit('','add')">新建</a-button>
    </div>
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :loading="loading"
      :rowKey="record => record.menuId"
      :pagination="false"
    >
    </a-table>
    <menu-add-or-update
      ref="menuAddOrUpdate"
      @ok="handleOk"/>
  </a-card>
</template>

<script>
import { fetchList, delObj } from '@api/sys/menu'
import MenuAddOrUpdate from './modules/menuAddOrUpdate'
export default {
  name: 'Menu',
  components: {
    MenuAddOrUpdate
  },
  data () {
    return {
      loading: false,
      columns: [
        {
          title: '菜单名称',
          dataIndex: 'title'
        }, {
          title: '菜单路由',
          dataIndex: 'path'
        }, {
          title: '路由名称',
          dataIndex: 'name'
        },
        {
          title: '是否隐藏本路由',
          dataIndex: 'hidden'
        }, {
          title: '图标',
          dataIndex: 'icon',
          customRender: (record) => {
            return (
              <div>
                <a-icon type={record} />
              </div>
            )
          }
        }, {
          title: '权限',
          dataIndex: 'perms'
        }, {
          title: '菜单类型',
          dataIndex: 'type'
        }, {
          title: '操作',
          width: '25%',
          customRender: (record) => {
            return (
              <div>
                <a-button
                  onClick={this.edit.bind(this, record)}
                  type="primary"
                  icon="edit"
                >修改</a-button>
                <a-divider type="vertical" />
                <a-popconfirm title="是否删除菜单" onConfirm={this.delete.bind(this, record)} okText="是" cancelText="否">
                  <a-icon slot="icon" type="question-circle-o" style="color: red" />
                  <a-button
                    icon="delete"
                    type="danger"
                  >删除</a-button>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a-button
                  onClick={this.show.bind(this, record)}
                  type="primary"
                  icon="edit"
                >查看</a-button>
              </div>
            )
          }
        }
      ],
      tableData: []
    }
  },
  methods: {
    init () {
      this.loading = true
      fetchList().then(res => {
        this.tableData = res.data
        this.loading = false
      })
    },
    edit (record) {
      console.log(record, 'edit')
      this.$refs.menuAddOrUpdate.edit(record.menuId, 'edit')
    },
    delete (record) {
      delObj(record.menuId).then(_ => {
        this.$message.info('删除成功')
        this.init()
      })
    },
    show (record) {
      this.$refs.menuAddOrUpdate.edit(record.menuId, 'show')
    },
    handleOk () {
      this.init()
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

</style>
